export default function(key, default_value)
{
    const from_ls = localStorage.getItem(key);
    return from_ls === null ? default_value : JSON.parse(from_ls);
}